import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import TdWeekDays from './tdWeekDays';
import TdSummary from './tdSummary';
import WheelInput from '../../../Common/wheelInput'
import { semanticColors, greyScaleColors } from '../../../Globals/styles';
import { Link } from 'react-router';

const ROOT = "ROOT";
const SECOND = "SECOND";
const THIRD = "THIRD";

export const types = {
  root: ROOT,
  second: SECOND,
  third: THIRD
}

class Tr extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isCollapsed: true,
    }
  }
  calcWeeklySum = () => {
    return ([
      this.props.mon,
      this.props.tue,
      this.props.wed,
      this.props.thu,
      this.props.fri,
      this.props.sat,
      this.props.sun
    ]
      .reduce((a, b) => a + b, 0));
  };
  toggleCollapse = () => {
    this.setState({
      isCollapsed: !this.state.isCollapsed
    })
  }
  createRootBtn = () => {
    const { id, type, name } = this.props;
    const { isCollapsed } = this.state
    return (
      <button
        onClick={() => this.toggleCollapse(id)}
        style={styles.btn[type]}
        type="button"
        className="dropdown-toggle  waves-btn"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false">
        {name}
        <i
          style={styles.i}
          className={!isCollapsed ?
            'fa fa-chevron-up' :
            'fa fa-chevron-down'}>
        </i>
      </button>
    )
  };
  createPlainBtn = () => {
    const { type, name } = this.props;
    return (
      <button
        style={styles.btn[type]}
        type="button"
        className="dropdown-toggle"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false">
        {name}
      </button>
    )
  };
  getPercentComplete = () => {
    return Math.floor(this.props.percentComplete)
  };
  delte = (root) => {
    const { showDelete } = this.props
    if (showDelete) {
    var style = {top: 8}
    if(root) {
      style = {
        position: 'absolute',
        left: -45,
        top: 8,
      }
    }
      return (<div className="col-xs-1" style={style} onClick={() => this.props.dh(root)}>
        <i style={{ marginTop: 5, cursor: 'pointer' }} className="fa fa-trash-o"></i>
      </div>)
    }
    return <div className="col-xs-1"></div>
  };
  render() {

    const { id, type, showingWeekdays, children, updatePercent, projectNumber, subIsCollapsed } = this.props;
    const { isCollapsed } = this.state

    var childrenWithProps = React.Children.map(children, child =>
      React.cloneElement(child, { subIsCollapsed: isCollapsed }));

    return (
      <div>
        <div className="row text-right" style={styles.row}>
          {type === ROOT ?
            <Link to={"/tilbud/sag/" + projectNumber + "/registrer/" + id}>
              <div className="col-xs-1 text-right" style={styles.infoBtn}>
                <i style={styles.fixWaves} className="fa fa-list-ul waves-icon"></i>
              </div>
            </Link> : null }
            {this.delte(type === ROOT)}
          <div style={{ height: '40px' }} className="col-xs-3" >
            {type === ROOT ? this.createRootBtn() : this.createPlainBtn()}
          </div>
          {showingWeekdays ?
            <TdWeekDays {...this.props} /> :
            <TdSummary
              {...this.props}
              weeklySum={this.calcWeeklySum()}
            >
              {type !== ROOT && children == null ? //if
                <WheelInput
                  maxValue={100}
                  minValue={0}
                  interval={5}
                  defaultValue={this.props.percentComplete}
                  onChange={(value) => updatePercent(id, value, this.props.percentComplete)}
                />
                : //else
                (
                  <div className="progress" style={styles.progress}>
                    <div
                      aria-valuenow={this.getPercentComplete()}
                      aria-valuemin="0"
                      aria-valuemax="100"
                      className="progress-bar"
                      role="progressbar"
                      style={[styles.progressbar, { 'width': this.getPercentComplete() + '%' }]}>
                      {this.getPercentComplete()}%
                </div>
                  </div>
                )
              }
            </TdSummary>
          }
        </div>
        <div>
          {/* show/hide children */}
          {!isCollapsed || subIsCollapsed === false ? childrenWithProps : null}
        </div>
      </div>
    );
  }
}


var styles = {
  row: {
    borderBottom: '1px solid',
    borderColor: greyScaleColors.greyLighter,
    height: '40px'
  },
  i: {
    position: 'absolute',
    right: '0',
    top: '13px'
  },
  infoBtn: {
    color: '#4a4a4a',
    display: 'inline-block',
    marginTop: '5px',
    height: '30px',
    lineHeight: '30px',
    borderRight: '1px solid',
    borderColor: semanticColors.mainBackground,
    cursor: 'pointer'
  },
  btn: {
    ROOT: {
      zIndex: '1000',
      height: '39px',
      width: '100%',
      backgroundColor: semanticColors.default,
      border: 'none',
      borderRadius: '0px',
      cursor: 'pointer',
      textAlign: 'left',
      fontWeight: '700',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      lineHeight: '37px',
      position: 'relative',
      padding: '0px'
    },
    SECOND: {
      height: '39px',
      width: '100%',
      backgroundColor: semanticColors.default,
      border: 'none',
      cursor: 'pointer',
      textAlign: 'left',
      borderRadius: '0px',
      fontWeight: '600',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      lineHeight: '37px',
      position: 'relative'
    },
    THIRD: {
      height: '39px',
      width: '100%',
      backgroundColor: semanticColors.default,
      border: 'none',
      cursor: 'pointer',
      textAlign: 'left',
      borderRadius: '0px',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      lineHeight: '37px',
      position: 'relative'
    }
  },
  progressbar: {
    minWidth: '2em',
    lineHeight: '30px',
    textAlign: 'right',
    paddingRight: '5px',
    fontWeight: '600',
    boxShadow: 'none',
    backgroundColor: semanticColors.info
  },
  progress: {
    height: '30px',
    marginTop: '5px',
    marginBottom: '0',
    boxShadow: 'none',
    backgroundColor: '#A8CEDC'
  },
  fixWaves: {
    height: '30px',
    width: '30px',
    lineHeight: '30px'
  }
}
Tr.propTypes = {
  type: PropTypes.oneOf([ROOT, SECOND, THIRD]).isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  mon: PropTypes.number.isRequired,
  tue: PropTypes.number.isRequired,
  wed: PropTypes.number.isRequired,
  thu: PropTypes.number.isRequired,
  fri: PropTypes.number.isRequired,
  sat: PropTypes.number.isRequired,
  sun: PropTypes.number.isRequired,
  estimated: PropTypes.number.isRequired,
  transferredTotal: PropTypes.number.isRequired,
  sumTotal: PropTypes.number.isRequired,
  percentComplete: PropTypes.number.isRequired,
  showingWeekdays: PropTypes.bool.isRequired,
  isCollapsed: PropTypes.bool,
  toggleCollapse: PropTypes.func,
  projectNumber: PropTypes.string.isRequired,
  updatePercent: PropTypes.func.isRequired
};
export default Radium(Tr)


// WEBPACK FOOTER //
// ./src/App/Project/WeekOverview/ActivityTable/tr.jsx